"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeFiles = exports.formatFileSize = void 0;
var dompurify = require("isomorphic-dompurify");
var common_utils_1 = require("./common-utils");
var formatFileSize = function (bytes) {
    var type = 'B';
    if (bytes / 1000 > 1) {
        bytes /= 1000;
        type = 'KB';
        if (bytes / 1000 > 1) {
            bytes /= 1000;
            type = 'MB';
        }
    }
    return "".concat(Math.round(bytes * 100) / 100, " ").concat(type);
};
exports.formatFileSize = formatFileSize;
var sanitizeFiles = function (files) {
    return files.map(function (file) {
        return new File([file.slice(0, file.size)], sanitizeFileName(file.name), {
            type: file.type,
            lastModified: file.lastModified,
        });
    });
};
exports.sanitizeFiles = sanitizeFiles;
var sanitizeFileName = function (fileName) {
    var ext = getExtension(fileName);
    var name = fileName.slice(0, fileName.lastIndexOf(ext));
    var newName = truncate(dompurify.sanitize(name).replace(/[^a-z0-9]/gi, '_'), 20) +
        '.' +
        dompurify.sanitize(ext).replace(/[^a-z0-9]/gi, '_');
    while (newName.includes('_')) {
        newName = newName.replace('_', (0, common_utils_1.getRandomCharacter)());
    }
    return newName;
};
var getExtension = function (filename) {
    var ext = filename.split('.').pop();
    return ext === filename ? '' : ext;
};
var truncate = function (str, n) {
    return str.length > n ? str.slice(0, n - 1) : str;
};
